export const createGroups = (translations) => {
  const data = [];
  translations.forEach((translation, index) => {
    const isFind = data.find((item) => item.name.includes(translation.group))
    if (!isFind) {
      data.push({
        name: translation.group,
        index: index + 1,
      });
    }
  })

  return data;
}
